import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class EfileEditKeyTableDataService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Save key table data - use application/x-www-form-urlencoded
  saveKeyTableData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(baseUrl, urlEncoded.toString(), httpOptions);
  }

  // Legacy alias from Gridsave mapping (AddEditKeyFactory.updateKeyTable)
  updateKeyTable(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    return this.saveKeyTableData(baseUrl, params, globalService, filterParams, rowData);
  }

  // CRITICAL: Delete key table data - use application/x-www-form-urlencoded
  deleteKeyTableData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(baseUrl, urlEncoded.toString(), httpOptions);
  }
}
